module.exports = __webpack_public_path__ + "static/media/background.230d1439.png";